import { render, staticRenderFns } from "./AddNotif.vue?vue&type=template&id=a9c56522&"
import script from "./AddNotif.vue?vue&type=script&lang=js&"
export * from "./AddNotif.vue?vue&type=script&lang=js&"
import style0 from "./notification.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports